<template>
  <v-container class="px-5 py-0">
    <v-layout py-6>
      <guest-balance py-6 />
    </v-layout>
    <subtitle :text="$t('actions.refund')" class="mb-3" />
    <v-layout justify-center mt-4 :mt-12="mdAndUp">
      <v-flex xs11 sm8 md7 lg6>
        <v-form ref="form">
          <v-layout column>
            <v-text-field
              :prefix="$t('fields.full_name')"
              v-model="fullName"
              class="mt-0 pt-0 required-prefix"
              autocomplete=off
            />
            <v-text-field
              :prefix="$t('fields.email')"
              v-model="email"
              :rules="[rules.email]"
              :error-messages="formErrors.email"
              class="mt-0 pt-0 required-prefix"
            />
            <v-text-field
              :prefix="$t('fields.swift')"
              v-model="swift"
              class="mt-0 pt-0 required-prefix"
            />
            <v-text-field
              autocomplete=off
              :prefix="$t('fields.bank_account')"
              class="mt-0 pt-0 required-prefix"
              v-model="bankAccountNumber"
            />
            <v-file-input
              :prefix="$t('fields.bank_account_cover_photo')"
              v-model="bankAccountImageFile"
              class="mt-0 pt-0 required-prefix"
              accept=".png, .svg, .jpg"
              :prepend-icon="null"
              :clearable="false"
              ref="image"
            >
              <template v-slot:append>
                <v-layout align-center>
                  <img v-if="bankAccountImageFile" :src="bankAccountImage" class="image mr-2">
                  <img :src="require('@/assets/Camera.png')" class="clickable image" @click="$refs.image.$refs.input.click()">
                </v-layout>
              </template>
            </v-file-input>
            <main-button v-if="isValid"
              :text="$t('actions.get_refund')"
              @click="checkForm()"
              class="mt-9"
            />
            <span class="body-2 mt-2 text-center">{{$t('refund.warning')}}</span>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
    <refund-request-dialog v-if="refund.edited" :refundRequest="refund.edited" :show="confirmDialog" @close="confirmDialog = false"  />
  </v-container>
</template>

<script>
import { fileToBase64 } from '@/lib/helpers/File'
import vuetifyMixins from '@/mixins/Vuetify'
import inputFormatMixins from '@/mixins/InputFormat'
import routeNames from '@/router/routes'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      bankAccountImage: null,
      confirmDialog: false,
      rules: {
        email: v => (!!v && new RegExp(/[a-zA-Z0-9._-]+@[a-z]+\.+[a-z]+/).test(v)) || this.$t('refund.errors.email')
      }
    }
  },
  computed: {
    ...mapState(['refund']),
    ...mapState({
      formErrors: state => state.state.formErrors || {}
    }),
    guestId () {
      return this.refund.edited ? this.refund.edited.guestId : null
    },
    fullName: {
      get () {
        return this.refund.edited ? this.refund.edited.fullName : null
      },
      set (value) {
        this.$store.commit('refund/setField', { field: 'fullName', value })
      }
    },
    email: {
      get () {
        return this.refund.edited ? this.refund.edited.email : null
      },
      set (value) {
        this.$store.commit('refund/setField', { field: 'email', value })
      }
    },
    swift: {
      get () {
        return this.refund.edited ? this.refund.edited.swift : null
      },
      set (value) {
        this.$store.commit('refund/setField', { field: 'swift', value: value.toUpperCase() })
      }
    },
    bankAccountNumber: {
      get () {
        return this.refund.edited ? this.refund.edited.bankAccountNumber : null
      },
      set (value) {
        this.$store.commit('refund/setField', { field: 'bankAccountNumber', value: value.toString() })
      }
    },
    bankAccountImageFile: {
      get () {
        return this.refund.edited ? this.refund.edited.bankAccountImageFile : null
      },
      set (value) {
        this.$store.commit('refund/setField', { field: 'bankAccountImageFile', value })
      }
    },
    isValid () {
      return !!this.fullName && !!this.email && !!this.swift && !!this.bankAccountNumber && !!this.bankAccountImageFile
    }
  },
  methods: {
    goToConfirm () {
      this.$router.push({ name: routeNames.refund_confirmation.name })
    },
    checkForm () {
      if (this.$refs.form.validate()) this.confirmDialog = true
    }
  },
  created () {
    this.$store.dispatch('guests/get', { id: this.guestId, save: true }).catch(() => {
      this.$router.go(-1)
    })
  },
  watch: {
    bankAccountImageFile (file) {
      this.bankAccountImage = null
      if (file) {
        fileToBase64(file).then((base64) => {
          this.bankAccountImage = base64
        })
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('refund/resetEdited')
  },
  components: {
    Subtitle: () => import('@/components/view-components/Subtitle.vue'),
    GuestBalance: () => import('@/components/view-components/GuestBalance.vue'),
    MainButton: () => import('@/components/app-components/MainButton.vue'),
    RefundRequestDialog: () => import('@/components/view-components/modals/RefundRequestDialog.vue')
  },
  mixins: [
    vuetifyMixins,
    inputFormatMixins
  ]
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field__slot {
    overflow: hidden;
  }
  .v-text-field__prefix {
    font-weight: 500 !important;
    padding-right: 20px;
  }
  input {
    font-weight: 500 !important;
    color: grey !important;
    &:focus {
      color: black !important;
    }
  }
  .v-input__slot {
    display: flex;
    flex-wrap: wrap;
  }
}
.image {
  max-height: 26px;
  width: 30px;
  margin-bottom: 4px;
}
</style>
